import type { ResultOf, VariablesOf } from 'gql.tada';

import { graphql } from '@flowtech/vendure-graphql-admin';

// #region DeleteRedirectsMutation
export const DELETE_REDIRECTS_MUTATION = graphql(`
  mutation DeleteRedirects($deleteRedirectsInput: DeleteRedirectsInput!) {
    deleteRedirects(deleteRedirectsInput: $deleteRedirectsInput) {
      succeeded
      error
    }
  }
`);
export type DeleteRedirectsMutation = typeof DELETE_REDIRECTS_MUTATION;
export type DeleteRedirectsResult = ResultOf<DeleteRedirectsMutation>;
export type DeleteRedirectsResultData =
  DeleteRedirectsResult['deleteRedirects'];
export type DeleteRedirectsVars = VariablesOf<DeleteRedirectsMutation>;
// #endregion

// #region ImportRedirectsMutation
export const IMPORT_REDIRECTS_MUTATION = graphql(`
  mutation ImportRedirects($file: Upload!) {
    importRedirects(file: $file) {
      totalProcessed
      succeeded
      failed
      errors {
        line
        message
      }
    }
  }
`);

export type ImportRedirectsResult = ResultOf<typeof IMPORT_REDIRECTS_MUTATION>;
export type ImportRedirectsResultData =
  ImportRedirectsResult['importRedirects'];
// #endregion

// #region RedirectListQuery
export const REDIRECT_LIST_QUERY = graphql(`
  query GetRedirectList($options: RedirectListOptions) {
    redirectList(options: $options) {
      items {
        id
        createdAt
        updatedAt
        source
        destination
        permanent
      }
      totalItems
    }
  }
`);
export type RedirectListQuery = typeof REDIRECT_LIST_QUERY;
export type RedirectListResult = ResultOf<RedirectListQuery>;
// #endregion

// #region CreateRedirectMutation
export const CREATE_REDIRECT_MUTATION = graphql(`
  mutation CreateRedirect($createRedirectInput: CreateRedirectInput!) {
    createRedirect(createRedirectInput: $createRedirectInput) {
      succeeded
      error
    }
  }
`);

export type CreateRedirectMutation = typeof CREATE_REDIRECT_MUTATION;
export type CreateRedirectResult = ResultOf<CreateRedirectMutation>;
export type CreateRedirectResultData = CreateRedirectResult['createRedirect'];
export type CreateRedirectVars = VariablesOf<CreateRedirectMutation>;
// #endregion

// #region RedirectsExportQuery
export const EXPORT_REDIRECTS_QUERY = graphql(`
  query ExportRedirects {
    exportRedirects {
      csvContent
    }
  }
`);

export type ExportRedirectsQuery = typeof EXPORT_REDIRECTS_QUERY;
export type ExportRedirectsResult = ResultOf<ExportRedirectsQuery>;
export type ExportRedirectsResultData =
  ExportRedirectsResult['exportRedirects'];
export type ExportRedirectsVars = VariablesOf<ExportRedirectsQuery>;
// #endregion
